import { render } from "./StockView.vue?vue&type=template&id=09540bd8&scoped=true"
import script from "./StockView.vue?vue&type=script&lang=js"
export * from "./StockView.vue?vue&type=script&lang=js"

import "./StockView.vue?vue&type=style&index=0&id=09540bd8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09540bd8"]])

export default __exports__